module.exports = __webpack_public_path__ + "img/DE00564.18b09087.png";